module.exports = __webpack_public_path__ + "static/media/huli_101.91cb0bfb.jpg";